import React from 'react'

import { ToggleGroup } from '@/components'
import { QrC2BType } from '@/types.ts'
import { useAppDispatch, useAppSelector } from '@/stores/hooks.ts'
import { c2bActions } from '@/stores/slices/c2b-slice.ts'

export const C2BTypeFilter = (): React.ReactElement | null => {
  const permissions = useAppSelector((state) => state.user.user?.permissions)

  const typeFilter = useAppSelector((state) => state.c2b.qrcType)
  const dispatch = useAppDispatch()

  const handleTypeChange = (_: unknown, item: QrC2BType | 'ALL') => {
    dispatch(
      c2bActions.setFilter({
        filterKey: 'qrcType',
        filterValue: item === 'ALL' ? undefined : item,
      })
    )
  }

  // если всего один отдел - фильтр не нужен
  if (!permissions?.showQrC2bStatic || !permissions.showQrC2b) return null

  return (
    <ToggleGroup<QrC2BType | 'ALL'>
      items={[
        { title: 'Все', value: 'ALL' },
        { title: 'Статический', value: '01' },
        { title: 'Динамический', value: '02' },
      ]}
      value={typeFilter || 'ALL'}
      onChange={handleTypeChange}
    />
  )
}
